import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import TagItem from './Item';
import style from './styles/style.module.css';

class TagDisplay extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            overflowing: false,
        };
        this.componentWidth = 0;
        this.totalWidth = 0;
    }
    componentDidMount() {
        this.componentWidth = parseInt( this.el.clientWidth ) || 0;
        if( !this.props.multiLine ) {
            this.determineOverflow();
        }
    }
    componentDidUpdate( prevProps ) {
        if( !this.props.multiLine ) {
            if( prevProps.screenWidth !== this.props.screenWidth ) {
                if( this.el && parseInt( this.el.clientWidth ) != parseInt( this.componentWidth ) ) {
                    this.componentWidth = parseInt( this.el.clientWidth ) || 0;
                    this.setState( { overflowing: this.totalWidth > this.componentWidth } );
                }
            }
            if( prevProps.tags.length !== this.props.tags.length ) {
                this.componentWidth = parseInt( this.el.clientWidth ) || 0;
                this.determineOverflow();
            }
        }

    }
    determineOverflow = () => {
        var overflowing = false;
        if( this.el && !this.props.multiLine ) {
            var maxWidth = parseInt( this.el.clientWidth ) || 0;
            var calculatedWidth = 0;
            var children = this.el.children;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var childStyle = child.currentStyle || window.getComputedStyle( child );
                var width = child.offsetWidth;
                var margin = parseFloat( childStyle.marginLeft ) + parseFloat( childStyle.marginRight );
                calculatedWidth += width;
                var isOverflowing = calculatedWidth > maxWidth;
                calculatedWidth += margin;
                this.totalWidth = calculatedWidth;
                overflowing = overflowing || isOverflowing;
            }
        }
        this.setState( { overflowing } );
    }
    render() {
        const { tags, itemProps } = this.props;
        return (
            <div className={ style.tagDisplay } style={ this.props.style }
            data-multiline={ this.props.multiLine } data-overflowing={ this.state.overflowing }
            ref={ ( el ) => { this.el = el; } }>
                { tags.map( ( item, index ) => {
                    if( item == null ) {
                        return null;
                    }
                    return ( <TagItem
                        deleteHandler={ this.props.deleteHandler != null ? () => { this.props.deleteHandler( index ); } : undefined }
                        title={ item.tagtext }
                        white={ this.props.white }
                        data-target='tag_item'
                        targetLink={ this.props.linked ? `/app/tag/${ item.tagtext }` : undefined }
                        { ...itemProps }
                        key={ item.tagid || `new-${ index }` } /> );
                } ) }
            </div>
        );
    }
}
TagDisplay.defaultProps = {
    tags: [],
    deleteHandler: null,
    linked: true,
    more: '#',
    itemProps: {},
};

const mapStateToProps = ( state ) => {
    return {
        screenWidth: state.screenSize.width,
    };
};


export default connect( mapStateToProps )( TagDisplay );
